import { all, call, put, takeLatest } from 'redux-saga/effects';
import axios from 'axios'

import {
  fetchDataForDashboardSuccess, fetchDataForDashboardFail,
  fetchUnpaidContractsForDashboardSuccess, fetchUnpaidContractsForDashboardFail
} from './actions';
import { FETCH_DASHBOARD_REQUEST, FETCH_UNPAID_CONTRACTS_REQUEST } from './actionTypes';
// from Auth
import { logout } from '../Auth/actions';
import { getOptions, processResponse } from '../../Utils/Utils';

const fetchContractsV2 = () => `/api/v2/graphql/b2b`

// Moved api call into own function (for easy test swapping)
export function fetchFromApi(options) {
  return axios(options)
    .then(response => ({ response }))
    .catch(error => ({ error }));
}

function* dashboard() {
  let graphqlQuery = `query {
    contracts(networkCode: "$networkCode", paginate:false){
      contractStatus
      lastTermEndDate
      currentTermEndDate
    }
  }`
  const body = JSON.stringify({
    query: graphqlQuery,
    getEntitiesByNetwork: true
  })

  const { response, error } = yield call(
    fetchFromApi,
    getOptions({ url: fetchContractsV2(), method: 'POST', data: body })
  );
  const { type, data, alerts } = processResponse({ response, error });
  switch (type) {
    case 'success':
      yield put(fetchDataForDashboardSuccess({ data }));
      break;
    case 'fail':
      yield put(fetchDataForDashboardFail({ error: alerts }));
      break;
    case 'logout':
      yield put(logout());
      break;
    default:
      break;
  }
  return { response, error };
}

function* unpaidContracts() {
  let graphqlQuery = `query {
    contracts(networkCode: "$networkCode", isUnpaid:true){
      contractStatus
    }
  }`
  const body = JSON.stringify({
    query: graphqlQuery,
    getEntitiesByNetwork: true
  })

  const { response, error } = yield call(
    fetchFromApi,
    getOptions({ url: fetchContractsV2(), method: 'POST', data: body })
  );
  const { type, data, alerts } = processResponse({ response, error });
  switch (type) {
    case 'success':
      yield put(fetchUnpaidContractsForDashboardSuccess({ data }));
      break;
    case 'fail':
      yield put(fetchUnpaidContractsForDashboardFail({ error: alerts }));
      break;
    case 'logout':
      yield put(logout());
      break;
    default:
      break;
  }
  return { response, error };
}

function* watchDashboard() {
  yield all([yield takeLatest(FETCH_DASHBOARD_REQUEST, dashboard)]);
  yield all([yield takeLatest(FETCH_UNPAID_CONTRACTS_REQUEST, unpaidContracts)]);
}

export default watchDashboard;
